/* eslint-disable max-len */
import React, {
    useContext, useState, useEffect, useCallback
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { ServiceManager } from '@jutro/legacy/services';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import { ViewModelForm, ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation, withValidation } from '@xengage/gw-portals-validation-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLNameDetailsComponent } from 'ml-components-common-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import { ScrollToError } from '@jutro/legacy/wizard-next';

import mlNewQuoteDialogModal from '../MLNewQuoteDialogModal/MLNewQuoteDialogModal';
import mlNewQuoteDialogModalMessages from '../MLNewQuoteDialogModal/MLNewQuoteDialogModal.messages';

import mlAccountsModalMessages from '../MLPossibleAccountsModal/MLPossibleAccountsModal.messages';
import mlPossibleAccountsModal from '../MLPossibleAccountsModal/MLPossibleAccountsModal.metadata.json5';
import mlAccountsModalStyles from '../MLPossibleAccountsModal/MLPossibleAccountsModal.module.scss';
import metadata from './MLNewQuoteAccountSearchComponent.metadata.json5';
import messages from './MLNewQuoteAccountSearchComponent.messages';

function MLNewQuoteAccountSearchComponent(props) {
    const modalApi = useModal();
    const { history, authHeader } = props;

    const localeService = ServiceManager.getService('locale-service');
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate, isComponentValid } = useValidation('NewQuoteAccountSearchComponent');
    const defaultCountryCode = localeService.getDefaultCountryCode();

    const [accountSearchCriteriaVM, updateAccountSearchCriteriaVM] = useState(undefined);
    const [showError, updateShowError] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);

    const { 
        showErrorModal,
        showProgressDialog,
        hideProgressDialog 
    } = MLModalService();

    useEffect(() => {
        const accountSearchCriteria = {
            country: defaultCountryCode,
            policyAddress_ML: {},
            contactType: 'person'
        };
        const accountSearchCriteriaView = viewModelService.create(accountSearchCriteria, 'pc', 'edge.capabilities.gateway.account.search.dto.AccountSearchCriteriaDTO');
        updateAccountSearchCriteriaVM(accountSearchCriteriaView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showNewQuoteDialog = useCallback((account) => {  
        const accountVM = viewModelService.create(account, 'pc', 'edge.capabilities.gateway.account.dto.AccountDTO');
        const overrides = {
            model: accountVM,
            history,
            isNewAccount: account?.isNewAccount ?? false
        };

        const componentProps = {
            title: translator(mlNewQuoteDialogModalMessages.startAQuote),
            overrideProps: overrides,
            CustomComponent: mlNewQuoteDialogModal,
            buttonType: 'filled',
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader
        };
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [history, translator, viewModelService]);


    const startNewAccountQuote = useCallback((account) => {
        showNewQuoteDialog({
            ...account,
            isNewAccount: account?.isNewAccount ?? false
        });
    }, [showNewQuoteDialog]);

    const createNewAccount = useCallback(async (accountHolder) => {
        const newAccount = {};
        _.set(accountHolder, 'primaryAddress.addressType', 'home');
        _.set(accountHolder, 'subtype', 'Person');
        newAccount.accountHolder = accountHolder;
        newAccount.producerCodes = accountHolder.producerCode && [{ code: accountHolder.producerCode }];

        try {
            showProgressDialog(platformMessages.loading);
            const newAccountResponse = await AccountService.getOrCreateAccount(newAccount, authHeader);
            hideProgressDialog();
            if (newAccountResponse.accountNumber > 0) {
                startNewAccountQuote(newAccountResponse);
            }
        } catch (err) {
            showErrorModal(messages.errorHeader, messages.couldNotCreateAccount);
        }
        return true;
    }, [authHeader, showErrorModal, startNewAccountQuote]);

    const initProducerCodes = useCallback((accountHolder) => {
        const userPromise = UserService.getCurrentUser(authHeader, true);
        userPromise.then((user) => {
            if (user.producerCodes_ML && user.producerCodes_ML.length) {
                _.set(user, 'producerCodes_ML', user.producerCodes_ML.filter((producerCode) => {
                    return producerCode.producerStatus_ML === 'Active';
                }));
            }
            _.set(accountHolder, 'producerCode', user.primaryProducerCode_ML.code);

            createNewAccount(accountHolder);
        });
    }, [authHeader, createNewAccount]);

    const startNewAccount = useCallback(() => {
        // if (modalScope) {
        //     modalScope.$dismiss();
        // }
        //transfer accountsearchview into new account object and start wizard
        const accountHolder = {
            firstName: accountSearchCriteriaVM.firstName.value,
            lastName: accountSearchCriteriaVM.lastName.value,
            middleName: accountSearchCriteriaVM.middleName_ML.value,
            suffix: accountSearchCriteriaVM.suffix_ML.value ? accountSearchCriteriaVM.suffix_ML.value.code : undefined,
            dateOfBirth: accountSearchCriteriaVM.dateOfBirth_ML.value,
            primaryAddress: accountSearchCriteriaVM.policyAddress_ML.value
        };

        initProducerCodes(accountHolder);
    }, [accountSearchCriteriaVM, initProducerCodes]);

    const startNewAccountFromPotentialAccountsModal = useCallback(() => {
        startNewAccount();
        MLTagManagerService.sendFormStepEvent('Customer lookUp', 'Customer LookUp_Add New Customer');
    }, [startNewAccount]);

    const queryExistingAccounts = useCallback(async () => {
        try {
            showProgressDialog(platformMessages.loading);
            const potentialExistingAccounts = await AccountService.getPotentialExistingAccounts(accountSearchCriteriaVM.value, authHeader);
            hideProgressDialog();
            
            MLTagManagerService.sendFormStepEvent('Customer Info Form', 'Customer info get started_continue');

            if (potentialExistingAccounts && potentialExistingAccounts.length > 0) {
                const searchedName = `${accountSearchCriteriaVM.firstName.value} ${accountSearchCriteriaVM.lastName.value}`;

                const formatPossibleAccountsHeader = () => {
                    return (
                        <FormattedMessage
                            {...mlAccountsModalMessages.duplicateCustomerLookup}
                            values={{
                                numberOfExistingCustomers: (<span className="ml-pill ml-pill-default-inverse large">{potentialExistingAccounts.length}</span>),
                                customerName: searchedName
                            }}
                        />
                    );
                };

                const potentialAccountsOverrideProps = () => {
                    const getSuffixName = (suffixCode) => {
                        const nameSuffixList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
                        const suffixTypeKeyName = nameSuffixList.getCode(suffixCode).name;
                        const suffixDisplayName = translator(
                            {
                                id: suffixTypeKeyName,
                                defaultMessage: ' '
                            }
                        );
                        return suffixDisplayName;
                    };

                    const getFullName = (accountHolder) => {
                        const middleName = accountHolder.middleName || '';
                        const suffix = accountHolder.suffix ? getSuffixName(accountHolder.suffix) : '';
                        return `${accountHolder.firstName} ${middleName} ${accountHolder.lastName} ${suffix}`;
                    };

                    const overrides = potentialExistingAccounts.map((account, index) => {

                        const goToAccountSummary = () => {
                            history.push(`/accounts/${account.accountNumber}/summary`)
                        };

                        const startNewQuote = () => {
                            showNewQuoteDialog({
                                ...account,
                                isNewAccount: true
                            });                         
                            MLTagManagerService.sendEvent('formStep', {
                                form: 'Customer lookUp',
                                stepName: 'Duplicate Customer Lookup_select'
                            });
                        };

                        return {
                            [`accountNumberLink${index}`]: {
                                onClick: goToAccountSummary,
                                content: _.capitalize(getFullName(account.accountHolder))
                            },
                            [`autoProduct${index}`]: {
                                visible: !_.isUndefined(account.numberOfAutoProducts_ML) && account.numberOfAutoProducts_ML > 0,
                                content: translator(mlAccountsModalMessages.numberOfProductsAuto, { numberOfProducts: account.numberOfAutoProducts_ML })
                            },
                            [`homeProduct${index}`]: {
                                visible: !_.isUndefined(account.numberOfHomeProducts_ML) && account.numberOfHomeProducts_ML > 0,
                                content: translator(mlAccountsModalMessages.numberOfProductsHome, { numberOfProducts: account.numberOfHomeProducts_ML })
                            },
                            [`umbrellaProduct${index}`]: {
                                visible: !_.isUndefined(account.numberOfUmbrellaProducts_ML) && account.numberOfUmbrellaProducts_ML > 0,
                                content: translator(mlAccountsModalMessages.numberOfProductUmbrella, { numberOfProducts: account.numberOfUmbrellaProducts_ML })
                            },
                            [`address${index}`]: {
                                content: _.get(account, 'accountHolder.primaryAddress.displayName', '')
                            },
                            [`phone${index}`]: {
                                content: _.get(account, 'accountHolder.maskedPrimaryPhoneNumber_ML', '')
                            },
                            [`selectButton${index}`]: {
                                onClick: startNewQuote
                            }
                        };
                    });

                    return Object.assign({}, ...overrides);
                };

                const overrides = {
                    possibleAccountsHeader: {
                        visible: !!searchedName,
                        content: formatPossibleAccountsHeader()
                    },
                    potentialAccountsIterable: {
                        data: potentialExistingAccounts
                    },
                    ...potentialAccountsOverrideProps()
                };

                const componentProps = {
                    title: translator(mlAccountsModalMessages.existingCustomersHeader),
                    uiProps: mlPossibleAccountsModal.componentContent,
                    actionBtnLabel: mlAccountsModalMessages.addNewCustomerButton,
                    viewModel: {},
                    modalBodyStyles: mlAccountsModalStyles,
                    additionalPEStyle: 'customPossibleAccountsModal',
                    overrideProps: overrides,
                    onSaveAction: startNewAccountFromPotentialAccountsModal,
                    removeSidesPadding: true,
                    messageNextToButton: translator(mlAccountsModalMessages.noneAreMatch),
                    buttonType: 'filled'
                };
                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            } else {
                startNewAccount();
            }
        } catch {
            showErrorModal(messages.errorHeader, messages.errorRetrieveInfo);
        }
    }, [
        accountSearchCriteriaVM,
        authHeader,
        showErrorModal,
        showNewQuoteDialog,
        startNewAccount,
        startNewAccountFromPotentialAccountsModal,
        translator,
        viewModelService
    ]);

    const setNextState = useCallback(() => {
        if (!isComponentValid || !accountSearchCriteriaVM.aspects.valid || !accountSearchCriteriaVM.aspects.subtreeValid) {
            updateShowError(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        }

        queryExistingAccounts();
    }, [accountSearchCriteriaVM, isComponentValid, queryExistingAccounts]);

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate,
            onContinue: setNextState
        },
        resolveComponentMap: {
            mlNameDetailsComponent: MLNameDetailsComponent
        }
    };

    const writeValue = useCallback((value, path) => {
        const newVM = viewModelService.clone(accountSearchCriteriaVM);
        _.set(newVM, path, value);
        updateAccountSearchCriteriaVM(newVM);
    }, [accountSearchCriteriaVM, updateAccountSearchCriteriaVM, viewModelService]);

    const overrideProps = {
        mlNameDetailsComponent: {
            personVM: accountSearchCriteriaVM,
            onValidate: onValidate,
            showValidationErrors: showError,
            onModelChange: writeValue
        },
        policyAddressContainer: {
            visible: !!_.get(accountSearchCriteriaVM, 'policyAddress_ML')
        },
        addressComponent: {
            onValueChange: writeValue,
            value: _.get(accountSearchCriteriaVM, 'policyAddress_ML'),
            sectionLabel: messages.insuredAddress,
            initialLockStateCity: false,
            showValidationErrors: showError
        },
        nextDescription: {
            content: (
                <FormattedMessage
                    {...messages.nextDescription}
                    values={{
                        confirmTheCustomer: (
                            <strong>{translator(messages.confirmTheCustomer)}</strong>
                        )
                    }}
                />
            )
        },
    };

    return (
        <React.Fragment>
            <ViewModelForm
                uiProps={metadata.pageContent}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                overrideProps={overrideProps}
                model={accountSearchCriteriaVM}
                onValidationChange={onValidate}
                onValueChange={writeValue}
                showErrors={showError}
            />
            <ScrollToError counter={errorTimestamp} />
        </React.Fragment>
    );
}

export default withRouter(withValidation(
    withViewModelService(withAuthenticationContext(MLNewQuoteAccountSearchComponent)))
);